import React, { FC } from 'react';
import { NoAvailability } from './NoAvailability';
import { MinimumNight } from './MininimumNight';
import { CheckoutClosed } from './CheckoutClosed';

import { InfoMessages } from './Messages.types';

export const Messages: FC<InfoMessages> = ({
  showNoAvailabilityMessage,
  currentSelectedDate,
  showMessage,
  setShowMessage,
}) => {
  return (
    <>
      <NoAvailability showNoAvailabilityMessage={showNoAvailabilityMessage} />
      {currentSelectedDate?.type !== 'check_in_closed' && (
        <MinimumNight
          currentSelectedDate={currentSelectedDate}
          showMessage={showMessage}
          setShowMessage={setShowMessage}
        />
      )}
      <CheckoutClosed
        currentSelectedDate={currentSelectedDate}
        showMessage={showMessage}
        setShowMessage={setShowMessage}
      />
    </>
  );
};
